'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FeaturedContentBlock = require('./components/FeaturedContentBlock.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FeaturedContentBlock).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/featured-content-block/lib/index.js
// module id = 1415
// module chunks = 1